// extracted by mini-css-extract-plugin
export var defaultWrapper = "_j1-3";
export var downloadButton = "_j1-4";
export var fileContainer = "_j1-9 _j1-7";
export var fileContainerBase = "_j1-7";
export var fileContainerFixedHeight = "_j1-8 _j1-7";
export var fileInfo = "_j1-5";
export var fileInfoWidthRestricted = "_j1-6";
export var fileType = "_j1-1";
export var fileTypeName = "_j1-2";
export var image = "_j1-0";
export var link = "_j1-b";
export var overflowEllipsis = "_j1-a";